import { fetchPublicApi } from '@/lib/api/apiServiceBase.ts';
import { BookingTourBasicDataDto } from '@/features/public/booking/types/BookingTourBasicDataDto.ts';
import { BookingQuoteDto } from '@/features/public/booking/types/BookingQuoteDto.ts';
import {
  BookingSpecificationRequest,
  ParticipantBookingSpecification,
} from '@/features/public/booking/types/BookingSpecificationRequest.ts';
import { BookingResponseDto } from '@/features/public/booking/types/BookingResponseDto.ts';
import CustomFieldDefinitionDto from '@/features/dashboard/tourCustomFields/types/_CustomFieldDefinitionDto.ts';
import { BookingOptionDto } from '@/features/public/booking/types/BookingOptionDto.ts';
import { TourConsentPreviewDto } from '@/features/public/booking/types/TourConsentPreviewDto.ts';
import { ConsentPreviewResponseDto } from '@/features/public/booking/types/ConsentPreviewResponseDto.ts';
import { BookingInsurancesDto } from '@/features/public/booking/types/BookingInsurancesDto.ts';

const bookingApi = {
  getBasicTourInfo: async (
    orgSlug: string,
    tourSlug: string,
  ): Promise<BookingTourBasicDataDto> => {
    return fetchPublicApi<BookingTourBasicDataDto>(
      'GET',
      `public/organizers/${orgSlug}/tours/${tourSlug}/about`,
    );
  },
  getQuote: async (
    orgSlug: string,
    tourSlug: string,
    request: BookingSpecificationRequest,
  ): Promise<BookingQuoteDto> => {
    return fetchPublicApi<BookingQuoteDto>(
      'POST',
      `public/organizers/${orgSlug}/tours/${tourSlug}/quote`,
      request,
    );
  },
  createBooking: async (
    orgSlug: string,
    tourSlug: string,
    request: BookingSpecificationRequest,
  ): Promise<BookingResponseDto> => {
    return fetchPublicApi<BookingResponseDto>(
      'POST',
      `public/organizers/${orgSlug}/tours/${tourSlug}/book`,
      request,
    );
  },
  getParticipantForm: async (
    orgSlug: string,
    tourSlug: string,
  ): Promise<CustomFieldDefinitionDto[]> => {
    return fetchPublicApi<CustomFieldDefinitionDto[]>(
      'GET',
      `public/organizers/${orgSlug}/tours/${tourSlug}/participant-form`,
    );
  },
  getBookingOptionForParticipant: async (
    orgSlug: string,
    tourSlug: string,
    participantBookingSpecification: ParticipantBookingSpecification,
  ): Promise<BookingOptionDto[]> => {
    return fetchPublicApi<BookingOptionDto[]>(
      'POST',
      `public/organizers/${orgSlug}/tours/${tourSlug}/tour-options`,
      participantBookingSpecification,
    );
  },
  getBookingInsurances: async (
    orgSlug: string,
    tourSlug: string,
  ): Promise<BookingInsurancesDto> => {
    return fetchPublicApi<BookingInsurancesDto>(
      'GET',
      `public/organizers/${orgSlug}/tours/${tourSlug}/insurances`,
    );
  },
  getTourConsents: async (
    orgSlug: string,
    tourSlug: string,
  ): Promise<TourConsentPreviewDto[]> => {
    return fetchPublicApi<TourConsentPreviewDto[]>(
      'GET',
      `public/organizers/${orgSlug}/tours/${tourSlug}/consents`,
    );
  },
  previewConsent: async (
    orgSlug: string,
    tourSlug: string,
    consentId: string,
    bookingSpecification: BookingSpecificationRequest,
  ): Promise<ConsentPreviewResponseDto> => {
    return fetchPublicApi<ConsentPreviewResponseDto>(
      'POST',
      `public/organizers/${orgSlug}/tours/${tourSlug}/consents/${consentId}/preview`,
      { bookingSpecification },
    );
  },
};

export default bookingApi;
